import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Rating from "semantic-ui-react/dist/es/modules/Rating/Rating.js";
export var Component = function Component(_ref) {
  var iconSize = _ref.iconSize,
      isShowingNumeral = _ref.isShowingNumeral,
      ratingNumber = _ref.ratingNumber;
  return React.createElement(Fragment, null, isShowingNumeral && ratingNumber, React.createElement(Rating, {
    disabled: true,
    maxRating: 5,
    rating: Math.round(ratingNumber),
    size: iconSize
  }));
};
Component.displayName = 'Rating';
Component.defaultProps = {
  iconSize: 'small',
  isShowingNumeral: true
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  iconSize: PropTypes.oneOf(['tiny', 'small']),
  isShowingNumeral: PropTypes.bool,
  ratingNumber: PropTypes.number.isRequired
} : {};